module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/HourlyPrecipitation50/Tokyo_HourlyPrecipitation50_MRI_RCP85_End.png";